































import Vue from 'vue';
import config from '../../../../config';
import TIcons from '../../../types/TIcons';
import LimitingPositionDisplay from '../LimitingPositionDisplay.vue';
import { ILimitingPosition } from '../../../common/interfaces/limiting.interface';

interface ILimitingProductInfoGridComponent {
  disabledCartIcon: string;
  exclusiveShoppingUrl: string;
  loading: boolean;
}

export default Vue.extend({
  components: { LimitingPositionDisplay },
  data(): ILimitingProductInfoGridComponent {
    return {
      disabledCartIcon: TIcons.limitingCartDisabledWhite,
      exclusiveShoppingUrl: config.wpUrls.exclusiveShopping,
      loading: true,
    };
  },
  props: {
    mode: {
      default: `product-list`,
      type: String,
    },
    position: {
      required: true,
      type: Object as () => ILimitingPosition,
    },
  },
  watch: {
    position: {
      deep: true,
      handler(): void { this.loading = this.position.current === 0; },
      immediate: true,
    },
  },
});
